module.exports = __webpack_public_path__ + "static/media/text.be7274ce.svg";